exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* overridden by src/lib/themes/guiHelpers.js */\n\nsection {\n    text-align: center;\n}\n\n.home_notification_dX3Ff {\n    background-color: var(--data-primary);\n    color: white;\n    max-width: 600px;\n    margin: auto;\n    padding: 10px;\n    border-radius: 10px;\n}\n\n.home_primary-button_3j_pp {\n    background-color: white;\n    color: var(--looks-secondary) !important;\n    border-radius: 8px;\n    padding: 16px;\n    text-decoration: none;\n    font-weight: 700;\n    display: inline-block;\n}\n\n.home_button_3kNx7 {\n    background-color: var(--motion-primary);\n    color: white;\n    border-radius: 8px;\n    padding: 8px 16px;\n    text-decoration: none;\n    display: inline-block;\n    font-weight: bold;\n}\n\n.home_button_3kNx7:hover {\n    background-color: var(--motion-tertiary);\n}\n\n.home_marginRight_Uw2kf {\n    margin-right: 8px;\n}", ""]);

// exports
exports.locals = {
	"notification": "home_notification_dX3Ff",
	"primary-button": "home_primary-button_3j_pp",
	"primaryButton": "home_primary-button_3j_pp",
	"button": "home_button_3kNx7",
	"marginRight": "home_marginRight_Uw2kf"
};